/* eslint-disable */
function getAMapApi() {
    if (window.AMap) Promise.resolve(window.AMap)
    return new Promise((resolve,reject) => {
        var url = 'https://webapi.amap.com/maps?v=1.4.15&key=5db4b1195ce5db1fe130511742737a15';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        jsapi.onload = function() {
            if (window.AMap) {
                resolve(window.AMap)
            } else {
                reject('地图api调用失败')
                document.head.removeChild(jsapi)
            }
        }
        document.head.appendChild(jsapi);
    })
}
function getPosition () {
    return new Promise( (resolve, reject) => {
        getGeolocationByBrowser().then( data => {
            resolve(data)
        }).catch( e => {
            getGeolocationByAMap().then ( data => {
                resolve(data)
            }).catch( e => {
                getPositionByCity().then(data => {
                    resolve(data)
                }).catch( e => {
                    reject(e)
                })
            })
        })
    })
}

function getPositionByCity () {
    return new Promise( async (resolve,reject) => {
        const AMap = await getAMapApi()
        AMap.plugin('AMap.CitySearch', function () {                    // ip定位
            var citySearch = new AMap.CitySearch()
            citySearch.getLocalCity(function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    const {city, province, bounds} = result
                    const position = bounds.getCenter()
                    resolve({
                        position,
                        areaData: {
                            province,
                            city,
                        },
                    })
                } else {
                    reject(e)
                }
            })
        })        
    })
}
async function getGeolocationByAMap () { // 高德精确定位
    const AMap = await getAMapApi()
    return new Promise ((resolve, reject) => {
        AMap.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                timeout: 3,          //超过10秒后停止定位，默认：5s
                buttonPosition:'RB',    //定位按钮的停靠位置
                buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
            });
            geolocation.getCurrentPosition(function(status,result){
                if(status=='complete'){
                    const {position, formattedAddress:address, addressComponent} = result   // 无延时\5s延时浏览器定位
                    const {province, city, district:country} = addressComponent
                    if (position && address && addressComponent ) {
                        resolve({
                            position,
                            address,
                            areaData: {
                                province,
                                city,
                                country
                            },
                        })
                    }
                    console.log('高德API浏览器定位成功！')
                }else{
                    reject(result)
                }
            });
        })    
    })
}
async function getGeolocationByBrowser () {
    return new Promise( (resolve,reject) => {
        if (navigator.geolocation) {
            var options = {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 10000
            };
            var success = async (pos) => {
                const {address, areaData} = await getPositionByCity ()
                var crd = pos.coords;
                resolve({
                    position: {
                        lng: crd.longitude,
                        lat: crd.latitude,
                    },
                    address,
                    areaData,
                })
                console.log('浏览器定位成功！')
            }
            var error = (err) => {
                reject('定位数据获取失败！')
            }
            const data = navigator.geolocation.getCurrentPosition(success, error, options)            
        }
        else {
            reject('浏览器不支持GeoLocation定位')
        }
    })
}

async function getDistance({lstLngLat, location}) {
    if ( !location || !location.lng || !location.lat ) return
    if ( !Array.isArray(lstLngLat) && lstLngLat.length<=0) return
    let results = []
    const AMap = await getAMapApi()
    results = lstLngLat.map( ({lng, lat}) => {
        let m1 = new AMap.Marker({
            position: new AMap.LngLat(location.lng, location.lat)
        });
        let m2 = new AMap.Marker({
            position:new AMap.LngLat(lng, lat)
        });
        let p1 = m1.getPosition();
        let p2 = m2.getPosition();
        if (p1 && p2) {
            return Math.round(p1.distance(p2))
        }
    })
    return results
}

async function getLocByAddr({address}) {
    if (!address) return 
    const AMap = await getAMapApi()
    return new Promise( (resolve,reject) => {
        AMap.plugin('AMap.Geocoder', function() {
            var geocoder = new AMap.Geocoder({
                city: '全国'
            })
            geocoder.getLocation(address, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    resolve(result.geocodes[0].location) // result中对应详细地理坐标信息
                }
                reject('获取编码失败!')
            })
        })
    })
}
function createSingleMap () {
    window.map = null
    return function({lng, lat}) {
        return new Promise (async (resolve, reject) => {
            if (window.map) return resolve(window.map)
            try {
                const AMap = await getAMapApi()

            } catch(e) {
                reject(e)
            }
            resolve(window.map)
        })
    }
}
const getSingleMap = createSingleMap()

function addIconMarker ({map, lng, lat, imgUrl}) {
    // 创建一个 Icon
    var icon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(50, 60),
        // 图标的取图地址
        image: imgUrl,
        // 图标所用图片大小
        imageSize: new AMap.Size(50, 60),
    });
    // 将 icon 传入 marker
    var marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        icon: icon,
        anchor: 'center', //设置锚点
    });
    map.add(marker)
}
// 坐标转换
async function convertFrom({lng, lat, type}={}){
    const AMap = await getAMapApi()
    return new Promise( (resolve, reject) => {
        AMap.convertFrom([lng,lat], type, function (status, result) {
            if (result.info === 'ok') {
                var resLnglat = result.locations[0];
                resolve(resLnglat)
            } else {
				resolve({
					lng,
                    lat
				})
			}
        });
    })
}

async function planPath({map, srcPos, desPos}) {
    var walkOption = {
        map: map,
        hideMarkers: false,
        isOutline: true,
        outlineColor: '#ffeeee',
        autoFitView: true
    }
    return new Promise( (resolve,reject) => {
        AMap.plugin('AMap.Driving', function() {
            var walking = new AMap.Driving(walkOption)
            //根据起终点坐标规划步行路线
            walking.search([srcPos.lng, srcPos.lat], [desPos.lng, desPos.lat], (status, result) => {
                if (status === 'complete') {
                    resolve('绘制驾车路线完成')
                } else {
                    reject('获取驾车数据失败：' + result)
                }
            })
        })  
    })

}

export {
    getAMapApi,                // 加载高德地图API
    getPosition,               // 根据ip获取城市定位
    getPositionByCity,
    getDistance,               // 根据经纬度获取距离
    getLocByAddr,              // 地址编码，查询经纬度
    getSingleMap,              // 获取唯一地图实例
    addIconMarker,             // 放置图片标记
    planPath,                  // 显示路线
    convertFrom,               // 坐标地址转换
}


// WEBPACK FOOTER //
// ./src/pages/store/amap.js